var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmartwatch = function SvgSmartwatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#smartwatch_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C09C6B",
    d: "M14.363 4.545H6.181l.031-.67.334-2.753c.032-.26.159-.499.357-.672.199-.173.455-.269.72-.268h5.298c.265 0 .522.095.72.268.199.173.326.412.357.672l.335 2.752zM14.363 14.909H6.181l.031.671.334 2.753c.032.259.159.498.357.671.199.173.455.269.72.269h5.298c.265 0 .522-.096.72-.269.199-.173.326-.412.357-.671l.335-2.753z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#smartwatch_svg__b)",
    d: "M14.09 4H6.455a1.91 1.91 0 0 0-1.909 1.91v7.636a1.91 1.91 0 0 0 1.91 1.909h7.636A1.91 1.91 0 0 0 16 13.545V5.91A1.91 1.91 0 0 0 14.09 4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.273 10.045a.32.32 0 0 1-.252-.123L7.794 7.058a.318.318 0 0 1 .502-.39l2.054 2.64L11.7 8.5a.318.318 0 0 1 .327.546l-1.59.954a.3.3 0 0 1-.164.046"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "smartwatch_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(125.013 4.197 5.58)scale(12.3012 13.0733)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D59A4F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "smartwatch_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.727.182h19.091v19.09H.728z"
  })))));
};
export default SvgSmartwatch;